import { render, staticRenderFns } from "./ResizableTextarea.vue?vue&type=template&id=623f1074&scoped=true&"
import script from "./ResizableTextarea.vue?vue&type=script&lang=js&"
export * from "./ResizableTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f1074",
  null
  
)

export default component.exports